import { Refresh } from '@mui/icons-material';
import { Box, IconButton, Skeleton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Ticket } from '@work4all/models/lib/Classes/Ticket.entity';

import { useServiceAccessContext } from '../../containers/mask-overlays/mask-overlay/views/ticket/components/service-access-controller/hooks/use-service-access-context';
import { serviceAccessStatusColors } from '../../containers/mask-overlays/mask-overlay/views/ticket/components/service-access-controller/ServiceAccessController';

export type IServiceAccessRequestCellProps = {
  value: string;
  row: { original: Ticket };
};

export const ServiceAccessRequestCell = (
  props: IServiceAccessRequestCellProps
) => {
  const { value } = props;

  const { internalRequests, refreshInternalRequests } =
    useServiceAccessContext();

  const internalRequest = internalRequests.find(
    (request) => request.ticketId === value
  );

  const { t } = useTranslation();

  return internalRequest ? (
    <Stack alignItems="center" direction="row" gap="0.5rem">
      <Box flexShrink={0}>
        <Skeleton
          variant="circular"
          width="1rem"
          height="1rem"
          style={{
            background: serviceAccessStatusColors[internalRequest?.status],
          }}
        />
      </Box>

      <Typography
        variant="body1"
        color="inherit"
        flexGrow={1}
        textOverflow="ellipsis"
        overflow="hidden"
      >
        {t(
          `TICKET.SERVICE_ACCESS_CONTROLLER.STATUS.${internalRequest?.status}`
        )}
      </Typography>
      <IconButton onClick={refreshInternalRequests}>
        <Refresh />
      </IconButton>
    </Stack>
  ) : null;
};
